
import { ShapeInfo } from './shapeInfo/shapeInfo'

//主にm_labelテーブル フレーム情報
export class FrameInfo{
    id : number = 0;
    orderNum : number = 0; //ピース番号
    leftMargin : number = 0; //左側の空白の間隔
    topMargin : number = 0; //上側の空白の間隔
    horizontalPadding : number = 0; //水平の空白の間隔
    verticalPadding : number = 0; //垂直の空白の間隔
    cuttingMargin : number = 0; //不明
    width : number = 0; //フレームの横幅
    height : number = 0; //フレームの縦幅
    col : number = 0; //列数
    row : number = 0; //行数
    bleed : boolean = false; //塗り足し指定フラグ(不明)..使ってない
    bleedWidth : number = 0; //塗り足し幅...使ってない
    bleedHeight : number = 0; //塗り足し高さ...使ってない
    shapeInfo : ShapeInfo = new ShapeInfo(); //フレームの形状に関する情報
}